import React, {useEffect} from 'react';
import {ValorantCategoryPageHero} from '../../components/ValorantCategoryPageHero/ValorantCategoryPageHero';
import {
  ClearFilter,
  CurrentFilterDescriptor,
  Pagination,
  RangeSlider,
  RefinementList,
  SearchBox,
  SortSelector,
} from '../../components/algolia-widgets';
import {FilterBarLayout} from '../../components/algolia-widgets/FilterBarLayout';
import {
  createURL,
  useSynchronizedQueryStringForSearchForPackages,
} from '../../components/algolia-widgets/useSynchronizedQueryStringForSearchForValorantPackages';
import {Configure, connectHits, InstantSearch} from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import {compact} from 'lodash';
import {ProductCard} from '../../components/ProductCard/ProductCard';
import {ValorantInfoSection} from '../../components/ValorantInfoSection/ValorantInfoSection';
import {EmptyState} from "../../components/EmptyState/EmptyState";
import {Helmet} from "react-helmet";
import {RegionFilter} from "../../components/algolia-widgets/RegionFilter";
import {
  useMetaDescriptionCorrespondingToFields
} from "../../components/algolia-widgets/useMetaDescriptionCorrespondingToFields";

const searchClient = algoliasearch(
  process.env.MIX_ALGOLIA_APP_ID,
  process.env.MIX_ALGOLIA_PUBLIC_KEY
);


export const Valorant = ({ type, ranked }) => {
  const { searchState, onSearchStateChange } =
    useSynchronizedQueryStringForSearchForPackages({
      automaticallyManagedRefinementLists: ['agents'],
      automaticallyManagedRanges: compact([
        'price',
        'min_skins',
        'min_agents',
        !ranked && 'min_credits',
      ]),
    });

  const {refinementList} = searchState;
  useMetaDescriptionCorrespondingToFields(
    refinementList.region_name,
    refinementList['tier'] ?? refinementList['rank.tier']
  );

  // keep in for prod debugging purposes
  console.log(searchState, type, ranked)

  const {region_name, tier} = searchState.refinementList
  const region = region_name?.length === 1 ? region_name[0] : ''
  const regionOrRank = tier?.length === 1 ? tier[0] : ''

  useEffect(() => {
    document.querySelector('#skeleton').style="display: none";
  }, []);

  const elements = [
    { name: 'Home', url: 'https://www.unrankedsmurfs.com/' },
    { name: 'Valorant', url: 'https://www.unrankedsmurfs.com/valorant' },
    { name: `${type} Valorant Accounts`, url: `/valorant-account/category/${type}` },
  ];

  if(regionOrRank && regionOrRank.toLowerCase() !== "unranked") {
    elements.push({ name: regionOrRank, url: `/valorant-account/category/${type}/${region}` })
  } else if(region) {
    elements.push({ name: region, url: `${elements[2].url}/${region}` })
  }

  const StaticDataMap = {
    unranked: {
      title: `Browse ${region} Unranked Valorant Accounts`,
      description:
        'All of the Valorant accounts mentioned here are level 2+, Unranked and are instantly eligible for the ranked queue. An ideal choice for those seeking to carve their own path, these accounts provide the perfect blank slate for you to explore different agents, strategies, and hone your skills. Begin your journey with an Unranked Smurf account!',
      image: '/images/valorant/valorant-unranked-page.png',
      secondTitle: 'Why get an Unranked Valorant Account',
      secondContent: ['Valorant is now the best competitive shooter. With hundreds of thousands of regular spectators for all VCT tournaments and millions checking in every day, it\'s unlikely to change very soon, especially given Riot Games\' expertise maintaining a robust esports industry. Because everyone aspires to be the greatest, competition is strong.',
        'The first step in climbing is practice, and effective practice necessitates removing outside elements from your game. To prevent ruining up your primary account\'s MMR, always practice a new agent or class on your smurf. Climbing on the new account is also more enjoyable. Play as your favorite agent and see how high you can get. UnrankedSmurfs helps you bypass the grind by providing hand leveled unranked Valorant Smurfs. You can enter ranked mode without having to grind through 20 levels. Try the most dependable accounts provider, as thousands of our clients have done.'],
      thirdTitle: 'Why buy Unranked Valorant Account from UnrankedSmurfs?',
      thirdContent: ['UnrankedSmurfs is the largest specialised store with League of Legends and Valorant accounts. So, you can rest certain that you are not buying" your account from some sketchy individual on the dark web; rather, you are dealing with a legitimate business. We have hundreds of accounts in stock, therefore we nearly always have what you need. If you can\'t find what you\'re searching for, please send us a note and we will do our best to make you happy.']
    },
    ranked: {
      title: `Browse ${region} Ranked Valorant Accounts`,
      description: `Welcome to the diverse universe of Ranked Valorant Smurf accounts. With a wide range of ranks to choose from, you can select an account that matches your skill level or offers a new challenge. Whether you're a novice or a veteran, there's a perfect Valorant Smurf account for you to redefine your gaming experience.`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get a Ranked Valorant Account?',
      secondContent: ['Valorant’s thrilling gameplay and unique agents have attracted millions of players worldwide. A Ranked Smurf account gives you the flexibility to choose your starting point in the Valorant universe. Whether you\'re seeking to learn, climb the ranks, or simply experience the game from a fresh perspective, there\'s a Valorant Smurf account with your name on it.',
        'With a Ranked Smurf account, you can set your own pace. Start from the bottom and learn the ropes, or dive right into high-stakes matches - the choice is yours. The freedom to choose allows you to enhance your skills and strategize according to your gameplay.'],
      thirdTitle: 'Why Buy Ranked Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['UnrankedSmurfs is your one-stop-shop for a plethora of Ranked Valorant Smurf accounts across various servers. Our collection caters to a broad spectrum of gamers - whether you\'re looking for a casual playthrough, a competitive thrill, or a fresh start, we\'ve got an account for you.',
        'We stand apart with our commitment to providing hand-leveled accounts, exceptional customer service, and competitive pricing. We understand the sting of a banned Valorant account, which is why we offer a free lifetime warranty on all purchases.',
        'In the unlikely event your Ranked Smurf account is banned for account sharing, we pledge to replace it swiftly with a new equivalent account. With UnrankedSmurfs, your Valorant journey remains uninterrupted. Choose us for your Ranked Valorant Smurf account needs, and enjoy a secure and satisfying gaming experience.']
    },
    Iron: {
      title: `Browse ${region} Iron Valorant Accounts`,
      description: `Start a new with an Iron rank Valorant account, providing you the opportunity to experiment with different agents and tactics. These accounts lay a robust foundation for players looking to redefine their gameplay and climb the ranks. Embark on a fresh journey in the world of Valorant with an Iron rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get an Iron Valorant Account?',
      secondContent: ['Valorant remains a global sensation, enticing millions of enthusiastic players worldwide striving for greatness. However, achieving success demands considerable practice and patience, while others merely seek the thrill of the game. What could be more satisfying than completely defeating your opponents or practicing among the lowest ranked Valorant players?',
        'Attaining Iron rank involves a steep de-ranking process, requiring numerous consecutive losses after reaching a certain level. Accomplishing this without attracting a ban is challenging, as intentionally losing games can lead to reports from other players. Avoid these risks by choosing from our extensive array of ranked accounts in every region.',
        'Whether you\'re looking for an Iron account to dominate your enemies, a Gold account to join your friends in duo matches, or a Diamond+ account to exhibit your prowess in higher tiers, there\'s no better place to buy a ranked Valorant account online. Don\'t forget to use the special coupon code at the top of the page to enjoy a generous discount on your ranked smurfs account. With our competitive prices and superior accounts, we\'re the go-to source for your account needs.'],
      thirdTitle: 'Why Buy Iron Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['We provide a broad array of ranked smurf accounts across multiple servers, catering to those who desire to play with friends at a specific tier, experience the game at different levels, or practice a new role and agent on an alternate account. Our dedication to providing hand-leveled accounts, unmatched customer service, and maintaining competitive prices with an outstanding lifetime warranty on all sales sets us apart from other Valorant account smurf sellers.',
        'For those who have experienced the disappointment of a banned Valorant account, we understand the pain of losing the time and money invested. That\'s why all of our accounts are hand-leveled by us, and we offer a free lifetime warranty on all purchases. If your ranked account is banned for account sharing, we\'ll provide you with a new ranked equivalent as soon as possible! Choose us to buy Iron Valorant accounts and enjoy a worry-free gaming experience.']
    },
    Bronze: {
      title: `Browse ${region} Bronze Valorant Accounts`,
      description: `Embark on an exciting journey with a Bronze rank Valorant account. Offering you an ideal platform to practice strategies and familiarize yourself with various agents, these accounts set the stage for players ready to climb the ranks and redefine their Valorant experience. Discover the exhilarating world of Valorant and kick-start your ascend with a Bronze rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get a Bronze Valorant Account?',
      secondContent: ['Valorant, with its strategic gameplay and unique agents, has attracted millions of players worldwide. Among its various ranks, Bronze offers a fulfilling blend of learning and competition, making it an excellent starting point for those embarking on their Valorant journey.',
        'A Bronze Valorant account allows you to immerse yourself in the game, acquaint yourself with its mechanics, and refine your strategies without the pressure of higher-tier gameplay. With our Bronze accounts, you can navigate through your learning curve at a comfortable pace, setting yourself up for future ranks.',
        'By opting for a Bronze account, you save time on the leveling grind and can directly dive into the heat of competitive matches. You can focus on improving your agent skills, perfecting your strategies, and experiencing the thrill of competitive play, all while avoiding the often-tedious initial grind.'],
      thirdTitle: 'Why Buy Bronze Valorant Accounts from Unranked Smurfs?',
      thirdContent: ['At UnrankedSmurfs, we pride ourselves on offering a diverse range of hand-leveled Valorant accounts across multiple servers. These Bronze rank accounts are ideal for players looking to familiarize themselves with the game\'s intricacies, learn from like-minded competitors, and build their path to higher tiers without the pressure of maintaining their rank on their main accounts.',
        'Our promise extends beyond just providing accounts. We are committed to delivering unparalleled customer service and maintaining competitive prices. If you\'ve ever experienced the frustration of losing a Valorant account due to a ban, you\'ll appreciate our customer-first approach. We understand the setback of losing the time and effort invested, which is why we offer a free lifetime warranty on all purchases.',
        'In the unfortunate event that your Bronze ranked account is banned for account sharing, rest assured that we\'ll promptly provide a new ranked equivalent, ensuring your gaming experience remains uninterrupted. Choose UnrankedSmurfs for your Bronze Valorant account needs and enjoy a seamless, worry-free gaming experience.']
    },
    Silver: {
      title: `Browse ${region} Silver Valorant Accounts`,
      description: `Take your gameplay a notch higher with a Silver rank Valorant account. Here's your chance to test your skills against improving players, learn more about your chosen agents, and master the intricacies of diverse maps. A Silver rank account creates a conducive environment for competitive play while allowing room for learning and improvement. Up your game and evolve as a player with a Silver rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get a Silver Valorant Account?',
      secondContent: ['Valorant has become a gaming sensation, engaging millions of players around the globe with its blend of strategic and shooter gameplay. While climbing the ranks requires dedication and skills, Silver rank in Valorant provides a balanced and competitive environment to test your mettle and improve your game strategies.',
        'With a Silver Valorant account, you\'ll find the perfect mix of challenge and excitement, offering ample opportunities to refine your agent skills, try new strategies, and learn from a broader player base. A Silver rank account propels you directly into the heart of the competitive action, enabling you to bypass the time-consuming leveling grind.'],
      thirdTitle: 'Why Buy Silver Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['UnrankedSmurfs is your go-to platform for a wide range of Valorant accounts across various servers. Our Silver Valorant accounts are ideal for players seeking a fair competitive setting to hone their skills or those who want to play with friends in the same tier.',
        'We take immense pride in providing hand-leveled accounts, superior customer service, and competitive prices. We understand the annoyance that can come with losing a Valorant account due to a ban. Therefore, we offer a free lifetime warranty on all purchases.',
        'Should your Silver ranked account be banned for account sharing, we guarantee to promptly replace it with a new ranked equivalent, ensuring your gaming journey continues uninterrupted. Trust Unranked Smurfs for your Silver Valorant account needs, and take advantage of a worry-free and thrilling gaming experience.']
    },
    Gold: {
      title: `Browse ${region} Gold Valorant Accounts`,
      description: `Delve deeper into the competitive realm of Valorant with a Gold rank account. Facing increasingly skilled opponents, you'll have the perfect opportunity to sharpen your strategies and refine your gameplay. A Gold rank account provides an ideal platform for players aiming for higher ranks and greater achievements. Take up the challenge and ascend through the ranks with a Gold rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get a Gold Valorant Account?',
      secondContent: ['Valorant, with its engaging blend of tactical shooter gameplay and unique agents, continues to captivate millions of players worldwide. The Gold rank, recognized for its competitive environment and skilled player base, offers a rewarding experience for players seeking to test their skills against adept opponents.',
        'A Gold Valorant account offers you the chance to delve directly into higher-tier gameplay, bypassing the time-consuming leveling process. Here, you\'ll get the chance to challenge yourself, hone your agent skills, and devise new strategies in a stimulating environment that fosters growth and learning.'],
      thirdTitle: 'Why Buy Gold Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['At UnrankedSmurfs, we are committed to providing a diverse range of hand-leveled Valorant accounts across multiple servers. These Gold rank accounts are perfect for players seeking to dive into the heat of competitive matches or hoping to play with friends in a more challenging tier.',
        'Our promise extends beyond just delivering accounts. We strive to provide top-tier customer service and competitive prices. We understand how frustrating losing a Valorant account to a ban can be, which is why we offer a free lifetime warranty on all purchases.',
        'In the unfortunate event that your Gold ranked account is banned for account sharing, we guarantee a swift replacement with a new ranked equivalent, ensuring your Valorant journey remains uninterrupted. Trust Unranked Smurfs for your Gold Valorant account needs, and immerse yourself in a seamless and worry-free gaming experience.']
    },
    Platinum: {
      title: `Browse ${region} Platinum Valorant Accounts`,
      description: `Elevate your Valorant journey with a Platinum rank account. Tackle fierce competitors, enhance your strategic approach, and refine your agent mastery in an environment that's challenging and rewarding. Platinum rank accounts offer the perfect battleground for dedicated players looking to scale the competitive ladder. Embrace the challenge and strive for excellence with a Platinum rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get a Platinum Valorant Account?',
      secondContent: ['Valorant, with its captivating combination of strategic gameplay and unique characters, attracts millions of passionate players globally. The Platinum rank offers a competitive yet enjoyable gaming environment, making it the ideal tier for players ready to take on tougher challenges and ascend to the game\'s higher ranks.',
        'With a Platinum Valorant account, you\'re launched straight into an advanced gameplay environment. This setting allows you to develop strategic insights, sharpen your skills, and learn from seasoned players, thus providing a thrilling and enriching gaming experience.'],
      thirdTitle: 'Why Buy Platinum Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['At UnrankedSmurfs, we are committed to providing a wide range of hand-leveled Valorant accounts across multiple servers. Our Platinum rank accounts are ideal for players aiming for an intense gaming experience, those wanting to compete against experienced opponents, or anyone eager to team up with friends in the same challenging tier.',
        'We stand out in the market for our superior customer service, competitive prices, and most importantly, our commitment to our customers\' gaming experience. We understand the frustration associated with losing a Valorant account to a ban. Thus, we offer a free lifetime warranty on all purchases.',
        'Should your Platinum ranked account be banned for account sharing, we assure you a prompt replacement with a new ranked equivalent, ensuring your gaming journey continues smoothly. Trust Unranked Smurfs for your Platinum Valorant account needs and dive into an unrivaled, worry-free gaming experience.']
    },
    Diamond: {
      title: `Browse ${region} Diamond Valorant Accounts`,
      description: `Reach new heights in your Valorant journey with a Diamond rank account. Compete against top-tier players, enhance your tactical prowess, and refine your gameplay in a challenging and rewarding setting. Diamond rank accounts are the go-to for determined players looking to carve their names amongst Valorant's elite. Step up to the challenge and showcase your excellence with a Diamond rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get a Diamond Valorant Account?',
      secondContent: ['Valorant, a fusion of tactical gameplay and diverse agent abilities, engages millions of devoted players worldwide. The Diamond rank, known for its highly competitive environment and exceptional player base, offers a uniquely rewarding experience for players aiming to test their skills against the game\'s finest.',
        'A Diamond Valorant account offers you an instant gateway to high-stakes gameplay. Here, you\'ll face seasoned opponents, adapt to complex strategies, and learn to play under pressure, thus providing an immersive and intense gaming experience.'],
      thirdTitle: 'Why Buy Diamond Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['At UnrankedSmurfs, we pride ourselves on offering a vast array of hand-leveled Valorant accounts across multiple servers. Our Diamond rank accounts are perfectly suited for players seeking to immerse themselves in Valorant\'s highest tiers of play, compete with experienced opponents, or join friends in this demanding tier.',
        'We distinguish ourselves through our exceptional customer service, competitive prices, and unwavering commitment to our customers\' gaming journey. We acknowledge the disappointment associated with losing a Valorant account to a ban. To mitigate this, we provide a free lifetime warranty on all purchases.',
        'Should your Diamond ranked account be banned due to account sharing, we promise a swift replacement with a new equivalent account, ensuring that your Valorant journey continues without interruption. Trust Unranked Smurfs for your Diamond Valorant account needs, and plunge into a streamlined, hassle-free gaming experience.']
    },
    Ascendant: {
      title: `Browse ${region} Ascendant Valorant Accounts`,
      description: `Launch into a high-stakes Valorant journey with an Ascendant rank account. Grapple with formidable opponents, perfect your tactical acumen, and ascend your gameplay in a challenging, yet rewarding, arena. Ascendant rank accounts are the prime choice for unwavering players looking to stamp their authority amongst Valorant's elite. Rise to the challenge and seize the pinnacle of success with an Ascendant rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get an Ascendant Valorant Account?',
      secondContent: ['Valorant, renowned for its exhilarating blend of strategic gameplay and diverse agent roster, captivates millions of hardcore players across the globe. The Ascendant rank, home to the top echelon of players, offers a highly competitive and gratifying experience for players seeking to test their mettle against Valorant\'s best.',
        'An Ascendant Valorant account offers you an instant gateway to high-stakes gameplay. Here, you\'ll face seasoned opponents, adapt to complex strategies, and learn to play under pressure, thus providing an immersive and intense gaming experience.'],
      thirdTitle: 'Why Buy Ascendant Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['At Unranked Smurfs, we are proud to offer an extensive selection of hand-leveled Valorant accounts across numerous servers. Our Ascendant rank accounts are an ideal fit for players craving a slice of Valorant\'s uppermost tier of play, those wanting to pit themselves against the game\'s best, or anyone desiring to team up with friends in this prestigious tier.',
        'We differentiate ourselves through our superior customer service, competitive pricing, and steadfast commitment to our customers\' gaming journey. We fully understand the frustration stemming from the loss of a Valorant account due to a ban. To alleviate this issue, we extend a free lifetime warranty on all our purchases.',
        'If your Ascendant ranked account is banned for account sharing, we guarantee a speedy replacement with a new equivalent account, ensuring that your Valorant journey resumes with minimal disruption. Place your trust in Unranked Smurfs for your Ascendant Valorant account needs, and immerse yourself in a seamless and worry-free gaming experience.']
    },
    Immortal: {
      title: `Browse ${region} Immortal Valorant Accounts`,
      description: `Elevate your Valorant prowess to unprecedented heights with an Immortal rank account. Engage in fierce battles against the game's most elite players, showcase your strategic brilliance, and establish your dominance in the competitive arena. Immortal rank accounts serve as a gateway for skilled players seeking recognition amongst Valorant's true legends. Embrace the challenge and unleash your unparalleled skills with an Immortal rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get an Immortal Valorant Account?',
      secondContent: ['Valorant, renowned for its dynamic gameplay and diverse cast of agents, entices millions of passionate players worldwide. The Immortal rank, the realm of Valorant\'s top-tier competitors, provides an unmatched level of intensity and prestige. It offers an opportunity for players to prove their mettle against the very best in the game.',
        'An Immortal Valorant account catapults you into the realm of the elite, where you\'ll face off against formidable adversaries, adapt to intricate strategies, and demonstrate your exceptional skills. It\'s an arena that demands unwavering focus, unwavering determination, and unwavering expertise.'],
      thirdTitle: 'Why Buy Immortal Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['Unranked Smurfs takes pride in providing a diverse selection of hand-leveled Valorant accounts across multiple servers. Our Immortal rank accounts are tailored for players seeking the pinnacle of Valorant competition, those aiming to challenge the game\'s true legends, or individuals looking to collaborate with friends in this distinguished tier.',
        'What sets us apart is our unparalleled customer service, competitive pricing, and unwavering commitment to our customers\' gaming experience. We understand the frustration that accompanies losing a Valorant account to a ban, which is why we offer a free lifetime warranty on all purchases.',
        'In the unlikely event that your Immortal ranked account is banned due to account sharing, we guarantee a swift replacement with a new equivalent account, ensuring a seamless continuation of your Valorant journey. Trust Unranked Smurfs for your Immortal Valorant account needs and immerse yourself in an unparalleled, worry-free gaming experience.']
    },
    Radiant: {
      title: `Browse ${region} Radiant Valorant Accounts`,
      description: `Enter the realm of legends with a Radiant rank Valorant account. Engage in fierce battles against the absolute best players in the game, demonstrate your extraordinary skills, and establish yourself as an unrivaled force in the competitive arena. Radiant rank accounts are the ultimate symbol of Valorant excellence, reserved for those who are truly legendary. Embrace the challenge and ascend to unparalleled heights with a Radiant rank account!`,
      image: '/images/valorant/valorant-ranked-page.png',
      secondTitle: 'Why Get a Radiant Valorant Account?',
      secondContent: ['Valorant, renowned for its dynamic gameplay and diverse agent roster, attracts millions of passionate players worldwide. The Radiant rank stands as the pinnacle of Valorant\'s competitive ladder, a prestigious realm reserved for the most skilled and dedicated players. It represents the epitome of excellence and serves as a platform to showcase your unmatched abilities.',
        'A Radiant Valorant account grants you access to an elite tier, where you\'ll face off against the game\'s true legends. Here, you\'ll be tested in intense battles, confront exceptional opponents, and push the boundaries of your skills to their limits. It\'s an environment that demands nothing short of greatness.'],
      thirdTitle: 'Why Buy Immortal Valorant Accounts from UnrankedSmurfs?',
      thirdContent: ['UnrankedSmurfs takes pride in offering a wide selection of hand-leveled Valorant accounts across multiple servers. Our Radiant rank accounts are tailor-made for players seeking to etch their names in Valorant history, those aiming to challenge and surpass the best of the best, or individuals looking to collaborate with friends in this exclusive tier.',
        'We distinguish ourselves through our unwavering commitment to customer satisfaction, competitive pricing, and exceptional customer service. We understand the frustration that can arise from losing a Valorant account to a ban, which is why we provide a free lifetime warranty on all purchases.',
        'In the rare event that your Radiant ranked account is banned due to account sharing, we guarantee a swift replacement with a new equivalent account, ensuring a seamless continuation of your radiant journey. Trust Unranked Smurfs for your Radiant Valorant account needs and embark on an extraordinary, worry-free gaming experience.']
    }
  };

  const metas = {
    "AP": {
      "Iron": {
        title: "Buy AP Valorant Iron Account | UnrankedSmurfs",
        description: "Embark on your valorant journey with our AP Iron Account. Begin your battle saga."
      },
      "Bronze": {
        title: "Buy AP Valorant Bronze Account | UnrankedSmurfs",
        description: "Boost your valorant performance with our AP Bronze Account. Conquer with courage."
      },
      "Silver": {
        title: "Buy AP Valorant Silver Account | UnrankedSmurfs",
        description: "Release your gaming spirit with our AP Silver valorant Account. Ascend the leaderboard."
      },
      "Gold": {
        title: "Buy AP Valorant Gold Account | UnrankedSmurfs",
        description: "Make strides in valorant with our AP Gold Account. Embrace the golden opportunity."
      },
      "Platinum": {
        title: "Buy AP Valorant Platinum Account | UnrankedSmurfs",
        description: "Rule the valorant battlefield with our AP Platinum Account. Platinize your gameplay."
      },
      "Diamond": {
        title: "Buy AP Valorant Diamond Account | UnrankedSmurfs",
        description: "Soar in valorant with our AP Diamond Account. Let your gaming prowess shine."
      },
      "Ascendant": {
        title: "Buy AP Valorant Ascendant Account | UnrankedSmurfs",
        description: "Delve into exclusive play with our AP Ascendant valorant Account. Elevate your ambition."
      },
      "Immortal": {
        title: "Buy AP Valorant Immortal Account | UnrankedSmurfs",
        description: "Secure your valorant legacy with our AP Immortal Account. The relentless reign supreme."
      },
      "Radiant": {
        title: "Buy AP Valorant Radiant Account | UnrankedSmurfs",
        description: "Experience the pinnacle of valorant with our AP Radiant Account. The radiant rise."
      }
    },
    "KR": {
      "Iron": {
        title: "Buy KR Valorant Iron Account | UnrankedSmurfs",
        description: "Start your valorant journey with our KR Iron Account. A champion's first step."
      },
      "Bronze": {
        title: "Buy KR Valorant Bronze Account | UnrankedSmurfs",
        description: "Lift your valorant game with our KR Bronze Account. The path to progress."
      },
      "Silver": {
        title: "Buy KR Valorant Silver Account | UnrankedSmurfs",
        description: "Unlock your valorant potential with our KR Silver Account. A leap towards the podium."
      },
      "Gold": {
        title: "Buy KR Valorant Gold Account | UnrankedSmurfs",
        description: "Move forward in valorant with our KR Gold Account. A step closer to glory."
      },
      "Platinum": {
        title: "Buy KR Valorant Platinum Account | UnrankedSmurfs",
        description: "Dominate valorant with our KR Platinum Account. For those who dare to dream."
      },
      "Diamond": {
        title: "Buy KR Valorant Diamond Account | UnrankedSmurfs",
        description: "Stand out in valorant with our KR Diamond Account. Diamonds are forever."
      },
      "Ascendant": {
        title: "Buy KR Valorant Ascendant Account | UnrankedSmurfs",
        description: "Dive into premium play with our KR Ascendant valorant Account. Reach for the stars."
      },
      "Immortal": {
        title: "Buy KR Valorant Immortal Account | UnrankedSmurfs",
        description: "Claim your place among valorant's greats with our KR Immortal Account. Immortality is within reach."
      },
      "Radiant": {
        title: "Buy KR Valorant Radiant Account | UnrankedSmurfs",
        description: "Enter the valorant's pinnacle with our KR Radiant Account. The ultimate triumph."
      }
    },
    "BR": {
      "Iron": {
        title: "Buy BR Valorant Iron Account | UnrankedSmurfs",
        description: "Kickstart your valorant saga with our BR Iron Account. The foundation of a champion."
      },
      "Bronze": {
        title: "Buy BR Valorant Bronze Account | UnrankedSmurfs",
        description: "Elevate your valorant status with our BR Bronze Account. Conquer the next level."
      },
      "Silver": {
        title: "Buy BR Valorant Silver Account | UnrankedSmurfs",
        description: "Release your inner competitor with our BR Silver valorant Account. Rise in the ranks."
      },
      "Gold": {
        title: "Buy BR Valorant Gold Account | UnrankedSmurfs",
        description: "Progress in valorant with our BR Gold Account. The path to prestige."
      },
      "Platinum": {
        title: "Buy BR Valorant Platinum Account | UnrankedSmurfs",
        description: "Rule valorant with our BR Platinum Account. Exclusive to the truly strategic."
      },
      "Diamond": {
        title: "Buy BR Valorant Diamond Account | UnrankedSmurfs",
        description: "Ascend in valorant with our BR Diamond Account. Shine bright like a diamond."
      },
      "Ascendant": {
        title: "Buy BR Valorant Ascendant Account | UnrankedSmurfs",
        description: "Delve into top-tier play with our BR Ascendant valorant Account. Reach new heights."
      },
      "Immortal": {
        title: "Buy BR Valorant Immortal Account | UnrankedSmurfs",
        description: "Secure your legacy with our BR Immortal valorant Account. For the relentless."
      },
      "Radiant": {
        title: "Buy BR Valorant Radiant Account | UnrankedSmurfs",
        description: "Join the valorant's elite with our BR Radiant Account. The quest for the peak."
      }
    },
    "LATAM": {
      "Iron": {
        title: "Buy LATAM Valorant Iron Account | UnrankedSmurfs",
        description: "Launch your valorant adventure with our LATAM Iron Account. Where every great story starts."
      },
      "Bronze": {
        title: "Buy LATAM Valorant Bronze Account | UnrankedSmurfs",
        description: "Boost your valorant trajectory with our LATAM Bronze Account. Embrace the next challenge."
      },
      "Silver": {
        title: "Buy LATAM Valorant Silver Account | UnrankedSmurfs",
        description: "Unleash your true potential in valorant with our LATAM Silver Account. Onwards to the battleground."
      },
      "Gold": {
        title: "Buy LATAM Valorant Gold Account | UnrankedSmurfs",
        description: "Advance in valorant with our LATAM Gold Account. The crown awaits."
      },
      "Platinum": {
        title: "Buy LATAM Valorant Platinum Account | UnrankedSmurfs",
        description: "Master valorant with our LATAM Platinum Account. For the rulers of the game."
      },
      "Diamond": {
        title: "Buy LATAM Valorant Diamond Account | UnrankedSmurfs",
        description: "Rise above in valorant with our LATAM Diamond Account. The choice of champions."
      },
      "Ascendant": {
        title: "Buy LATAM Valorant Ascendant Account | UnrankedSmurfs",
        description: "Dive into elite gameplay with our LATAM Ascendant valorant Account. Fly high in the ranks."
      },
      "Immortal": {
        title: "Buy LATAM Valorant Immortal Account | UnrankedSmurfs",
        description: "Carve your name among valorant's finest with our LATAM Immortal Account. For the unstoppable."
      },
      "Radiant": {
        title: "Buy LATAM Valorant Radiant Account | UnrankedSmurfs",
        description: "Join the valorant elite with our LATAM Radiant Account. The pursuit of absolute mastery."
      }
    },
    "EUW": {
      "Iron": {
        title: "Buy EUW Valorant Iron Account | UnrankedSmurfs",
        description: "Embark on your valorant quest with our EU Iron Account. The beginning of a grand journey."
      },
      "Bronze": {
        title: "Buy EUW Valorant Bronze Account | UnrankedSmurfs",
        description: "Upgrade your valorant progress with our EU Bronze Account. Your next step to greatness."
      },
      "Silver": {
        title: "Buy EUW Valorant Silver Account | UnrankedSmurfs",
        description: "Maximize your valorant prowess with our EU Silver Account. The gateway to higher competition."
      },
      "Gold": {
        title: "Buy EUW Valorant Gold Account | UnrankedSmurfs",
        description: "Stand out in valorant with our EU Gold Account. Seize your deserved recognition."
      },
      "Platinum": {
        title: "Buy EUW Valorant Platinum Account | UnrankedSmurfs",
        description: "Rule the game with our EU Platinum valorant Account. Exclusively for the truly ambitious."
      },
      "Diamond": {
        title: "Buy EUW Valorant Diamond Account | UnrankedSmurfs",
        description: "Elevate your valorant status with our EU Diamond Account. For players seeking the pinnacle."
      },
      "Ascendant": {
        title: "Buy EUW Valorant Ascendant Account | UnrankedSmurfs",
        description: "Soar through top-tier gameplay with our EU Ascendant valorant Account. Reach for the stars."
      },
      "Immortal": {
        title: "Buy EUW Valorant Immortal Account | UnrankedSmurfs",
        description: "Secure your spot among the legends with our EU Immortal valorant Account. The epitome of persistence."
      },
      "Radiant": {
        title: "Buy EUW Valorant Radiant Account | UnrankedSmurfs",
        description: "Become part of valorant's elite with our EU Radiant Account. For those who strive for perfection."
      },
    },
    "NA": {
      "Iron": {
        title: "Buy NA Valorant Iron Account | UnrankedSmurfs",
        description: "Start your valorant journey with our NA Iron Account. A perfect beginning."
      },
      "Bronze": {
        title: "Buy NA Valorant Bronze Account | UnrankedSmurfs",
        description: "Take a step forward in valorant with our NA Bronze Account. Made for those ready to rise."
      },
      "Silver": {
        title: "Buy NA Valorant Silver Account | UnrankedSmurfs",
        description: "Unlock your potential in valorant with our NA Silver Account. The ideal choice for aspiring competitors."
      },
      "Gold": {
        title: "Buy NA Valorant Gold Account | UnrankedSmurfs",
        description: "Excel in valorant with our NA Gold Account. For players ready to claim their glory."
      },
      "Platinum": {
        title: "Buy NA Valorant Platinum Account | UnrankedSmurfs",
        description: "Dominate the game with our NA Platinum valorant Account. For the dedicated and determined."
      },
      "Diamond": {
        title: "Buy NA Valorant Diamond Account | UnrankedSmurfs",
        description: "Ascend to greatness in valorant with our NA Diamond Account. For the truly committed players."
      },
      "Ascendant": {
        title: "Buy NA Valorant Ascendant Account | UnrankedSmurfs",
        description: "Experience high-tier gameplay with our NA Ascendant valorant Account. Aim for the peak."
      },
      "Immortal": {
        title: "Buy NA Valorant Immortal Account | UnrankedSmurfs",
        description: "Claim your place among the best with our NA Immortal valorant Account. For the relentless."
      },
      "Radiant": {
        title: "Buy NA Valorant Radiant Account | UnrankedSmurfs",
        description: "Join the elite in valorant with our NA Radiant Account. For the absolute best."
      },
    }
  };

  let metaTitle = "Ranked Valorant Smurf Accounts | UnrankedSmurfs"
  let metaDesc = "Get a head start in Valorant with our selection of Ranked Smurf Accounts. Skillfully curated to give you an edge, these accounts are your first step towards Valorant greatness."

  if(ranked) {
    if(metas?.[region]?.[regionOrRank]) {
      metaTitle = metas?.[region]?.[regionOrRank].title
      metaDesc = metas?.[region]?.[regionOrRank].description
    }
  }

  const staticData = StaticDataMap[regionOrRank] || StaticDataMap[region] || StaticDataMap[type]

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
      </Helmet>
    <div className="valorant-category-page">
      <ValorantCategoryPageHero {...staticData} elements={elements}/>
      <div className="valorant-category-page__search">
        <InstantSearch
          indexName="valorant_packages"
          searchClient={searchClient}
          searchState={searchState}
          onSearchStateChange={onSearchStateChange}
          createURL={createURL}
        >
          <Configure filters={`ranked:${ranked}`} hitsPerPage={40} />
          <FilterBarLayout
            regionWidget={
              <RegionFilter attribute="region_name"
                            defaultRegions={['NA', 'EUW', 'EUNE', 'BR', 'OCE', 'LAN', 'JP', 'LAS', 'TR', 'RU']}/>
            }
            widgets={
              <React.Fragment>
                <SearchBox placeholder="Search our store" />
                {ranked && (
                  <RefinementList
                    attribute="tier"
                    name="Rank"
                    limit={100}
                    searchable
                  />
                )}
                <RangeSlider attribute="price" name="Price" unit="$" />
                <RangeSlider attribute="min_agents" name="Agents" />
                {!ranked && (
                  <RangeSlider
                    attribute="min_credits"
                    name="Credits"
                    side="left"
                  />
                )}
              </React.Fragment>
            }
            bottomLeftWidgets={<CurrentFilterDescriptor />}
            bottomRightWidgets={
              <React.Fragment>
                <ClearFilter />
                <SortSelector
                  defaultRefinement="valorant_packages"
                  items={[
                    {
                      value: 'valorant_packages_price_asc',
                      label: 'Price|asc',
                    },
                    {
                      value: 'valorant_packages_price_desc',
                      label: 'Price|desc',
                    },
                    {
                      value: 'valorant_packages_by_agents_count_asc',
                      label: 'Agents|asc',
                    },
                    {
                      value: 'valorant_packages_by_agents_count_desc',
                      label: 'Agents|desc',
                    },
                  ]}
                />
              </React.Fragment>
            }
          />

          <PackagesList />

          <Pagination />
        </InstantSearch>
      </div>
      <ValorantInfoSection content={staticData} />
    </div>
    </>
  );
};

const PackagesList = connectHits(({ hits }) => {
  if (hits.length === 0) {
   return (
      <div className="valorant-category-page__search-container">
        <EmptyState />
      </div>
   )}


  return (
    <div className="valorant-category-page__search-container">
      {hits.map((hit) => (
        <ProductCard {...hit} key={hit.id} />
      ))}
    </div>
  );
});
